// extracted by mini-css-extract-plugin
export var text = "_redotech-redo-web-lib-arbiter-components-common-descriptors-text";